import React from "react";
import moment from "moment";
import EditBatteryComp from "../common/EditBatteryComp";
import EditActionsComp from "../common/EditActionsComp";
import EditInstallBeforeDateComp from "../common/EditInstallBeforeDateComp";
import CommonDatePicker from "../../../../../common/components/DatePickers/CommonDatePicker";
import { FormatDate } from "../../../../../common/helper";
import { HandleUnknow } from "../../../../../common/helper/BasicFn";
import { printConsole } from "../../../../../common/helper/Common";

/*
const EditInstallBeforeDateComp = () =>
{
    return (
        <>

            <div className='col-3 form-group' >
                <label htmlFor="">Install Before Date</label>
                <CommonDatePicker
                    is_readonly={is_unknowntrue}
                    disabled={is_unknowntrue}
                    calName={ 'install_before_date' }
                    CalVal={ crrFormData?.install_before_date }
                    HandleChange={ handleDateChange }
                />
            </div>
        </>
    )
}
*/
const defaultDate = moment().format("MM/DD/YY");
const InstalledDate = ({ is_unknowntrue, crrFormData, handleDateChange }) => {
  printConsole({ crrFormData }) // print console.log


  return (
    <>
      <div className="col form-group" style={{ maxWidth: "300px" }}>
        <label htmlFor="">Installed Date</label>
        <CommonDatePicker
          is_readonly={is_unknowntrue}
          disabled={is_unknowntrue}
          calName={"date_installed"}
          // If crrFormData?.date_installed is undefined, use the default current date
          CalVal={crrFormData?.date_installed}
          HandleChange={handleDateChange}
        />
      </div>
    </>
  );
};


const MenufectureDate = ({ is_unknowntrue, crrFormData, handleDateChange }) => {
  return (
    <>
      <div className="col form-group">
        <label htmlFor="">Manufactured Date</label>
        <CommonDatePicker
          is_readonly={is_unknowntrue}
          disabled={is_unknowntrue}
          calName={"manufactured_date"}
          CalVal={crrFormData?.manufactured_date}
          HandleChange={handleDateChange}
        />
      </div>
    </>
  );
};

const BatteryExpiery = ({ is_unknowntrue, crrFormData, handleDateChange }) => {
  return (
    <>
      <div className="col form-group">
        <label htmlFor="">Battery Expiration</label>

        <CommonDatePicker
          is_readonly={is_unknowntrue}
          disabled={is_unknowntrue}
          calName={"battery_expiration"}
          CalVal={crrFormData?.battery_expiration}
          HandleChange={handleDateChange}
        />
      </div>
    </>
  );
};

function EditBatteryinformation({
  crrIndex,
  formData,
  setFormData,
  keyName,
  Permissins,
  bettery_type,
  crrFormData,
  BatteryList,
  is_unknowntrue,
  is_spare_manu = 0,
  unKnownToggleKey,
  showAddRow,
  setShowAddRow,
}) {

  const handleInputChange = (e, index) => {
    let name = e.target.name;
    let val = e.target.value;

    const oldData = { ...formData };
    oldData[keyName][index][name] = val;
    setFormData(oldData);
  };
  const handleDateChange = (name, val) => {
    const oldData = { ...formData };
    printConsole({ oldData, keyName, crrIndex, name }) // print console.log
    oldData[keyName][crrIndex][name] = val;
    if (
      name === "date_installed" &&
      (bettery_type !== 1 || bettery_type !== 2)
    ) {
      let add_year = BatteryList.find(
        (item) =>
          parseInt(item.battery_type_id) ===
          parseInt(oldData[keyName][crrIndex]["battery_type_id"])
      );
      // .calendar()
      let battery_expiration = FormatDate(
        moment(val).add(add_year?.lifespan, "years")
      );

      oldData[keyName][crrIndex]["battery_expiration"] = battery_expiration;
    }

    setFormData(oldData);
  };

  if (bettery_type === 5) {
    return (
      <>
        <div className="row" key={crrIndex}>
          <EditBatteryComp
            formData={formData}
            crrFormData={crrFormData}
            BatteryList={BatteryList}
            handleInputChange={handleInputChange}
            crrIndex={crrIndex}
            is_readonly={is_unknowntrue}
          />
          {/* <EditInstallBeforeDateComp 
                is_unknowntrue={is_unknowntrue} 
                crrFormData={crrFormData} 
                handleDateChange={handleDateChange} 
                /> */}
          <InstalledDate
            is_unknowntrue={is_unknowntrue}
            crrFormData={crrFormData || defaultDate}
            handleDateChange={handleDateChange}
          />

          <EditActionsComp
            index={0}
            crrIndex={crrIndex}
            formData={formData}
            setFormData={setFormData}
            section_name={keyName}
            crrFormData={crrFormData}
            unKnownToggleKey={unKnownToggleKey}
            type={"battery"}
            showAddRow={showAddRow}
            setShowAddRow={setShowAddRow}
            is_unknowntrue={is_unknowntrue}
          />
        </div>
      </>
    );
  }

  if (bettery_type === 4) {
    return (
      <>
        <div class="row" key={crrIndex}>
          <div class="col-12">
            <hr />
          </div>
          <div className="row">
            <EditBatteryComp
              formData={formData}
              crrFormData={crrFormData}
              BatteryList={BatteryList}
              handleInputChange={handleInputChange}
              crrIndex={crrIndex}
              is_readonly={is_unknowntrue}
            />

            <MenufectureDate
              is_unknowntrue={is_unknowntrue}
              crrFormData={crrFormData}
              handleDateChange={handleDateChange}
            />

            <InstalledDate
              is_unknowntrue={is_unknowntrue}
              crrFormData={crrFormData || defaultDate}
              handleDateChange={handleDateChange}
            />
            {/* )} */}

            <div className="col-3 form-group">
              <label htmlFor="">Battery lot</label>
              <input
                className="form-control"
                type="text"
                id=""
                value={HandleUnknow(
                  formData?.[keyName]?.[crrIndex]?.battery_lot
                )}
                onChange={(e) => handleInputChange(e, crrIndex)}
                disabled={is_unknowntrue}
                name="battery_lot"
              />
            </div>

            <div className="col-3 form-group">
              <label htmlFor="">Battery UDI</label>
              {/* <input className='form-control' type="text" id="" value={HandleUnknow( formData?.[ keyName ]?.[ crrIndex ]?.battery_uid) } onChange={ (e) => handleInputChange(e, crrIndex) } disabled={is_unknowntrue} name="battery_udi"  /> */}
              <input
                className="form-control"
                type="text"
                id=""
                value={HandleUnknow(crrFormData?.battery_udi)}
                onChange={(e) => handleInputChange(e, crrIndex)}
                disabled={is_unknowntrue}
                name="battery_udi"
              />
            </div>

            <EditActionsComp

              index={0}
              crrIndex={crrIndex}
              formData={formData}
              setFormData={setFormData}
              section_name={keyName}
              crrFormData={crrFormData}
              unKnownToggleKey={unKnownToggleKey}
              type={"battery"}
              showAddRow={showAddRow}
              setShowAddRow={setShowAddRow}
            />
          </div>
        </div>
      </>
    );
  }

  if (bettery_type === 3) {
    return (
      <>
        <div className="col" key={crrIndex}>
          <div className="col-12">
            <hr />
          </div>

          <div className="row">
            <div className="col form-group">
              <EditBatteryComp
                formData={formData}
                crrFormData={crrFormData}
                BatteryList={BatteryList}
                handleInputChange={handleInputChange}
                crrIndex={crrIndex}
                is_readonly={is_unknowntrue}
              />
            </div>

            <div className="col form-group">
              <EditInstallBeforeDateComp
                is_unknowntrue={is_unknowntrue}
                crrFormData={crrFormData}
                handleDateChange={handleDateChange}
              />
            </div>

            <div className="col form-group">
              <InstalledDate
                value={defaultDate}
                is_unknowntrue={is_unknowntrue}
                crrFormData={crrFormData}
                handleDateChange={handleDateChange}
              />
            </div>

            <div className="col form-group">
              <label htmlFor="">Battery lot</label>
              <input
                className="form-control"
                type="text"
                id=""
                value={HandleUnknow(
                  formData?.[keyName]?.[crrIndex]?.battery_lot
                )}
                onChange={(e) => handleInputChange(e, crrIndex)}
                disabled={is_unknowntrue}
                name="battery_lot"
              />
            </div>

            <div className="col form-group">
              <label htmlFor="">Battery UDI</label>
              {/* <input className='form-control' type="text" id="" value={HandleUnknow( formData?.[ keyName ]?.[ crrIndex ]?.battery_uid) } onChange={ (e) => handleInputChange(e, crrIndex) } disabled={is_unknowntrue} name="battery_udi" /> */}
              <input
                className="form-control"
                type="text"
                id=""
                value={HandleUnknow(crrFormData?.battery_udi)}
                onChange={(e) => handleInputChange(e, crrIndex)}
                disabled={is_unknowntrue}
                name="battery_udi"
              />
            </div>

            <div className="col form-group">
              <label htmlFor="">Serial #</label>
              <input
                onChange={(e) => handleInputChange(e, crrIndex)}
                className="form-control"
                type="text"
                id=""
                value={HandleUnknow(crrFormData?.battery_serial)}
                name="battery_serial"
                disabled={is_unknowntrue}
              />
            </div>

            <EditActionsComp
              index={0}
              crrIndex={crrIndex}
              formData={formData}
              setFormData={setFormData}
              section_name={keyName}
              crrFormData={crrFormData}
              unKnownToggleKey={unKnownToggleKey}
              type={"battery"}
              showAddRow={showAddRow}
              setShowAddRow={setShowAddRow}
            />
          </div>
        </div>
      </>
    );
  }

  if (bettery_type === 2) {
    return (
      <>
        <div className="row" key={crrIndex}>
          <div className="col-12">
            <hr />
          </div>
          <EditBatteryComp
            formData={formData}
            crrFormData={crrFormData}
            BatteryList={BatteryList}
            handleInputChange={handleInputChange}
            crrIndex={crrIndex}
            is_readonly={is_unknowntrue}
          />
          {/* <div classNa form-group' >
                <label htmlFor="">Battery Part </label>
                <input className='form-control' type="text"  id="" value={formData?.[keyName]?.[crrIndex]?.battery_type_id} onChange={(e)=>handleInputChange(e,crrIndex)} disabled={is_unknowntrue} name="battery_type_id"  />
              </div> */}

          {/* <div className='col-3 form-group' >
                <label htmlFor="">Battery Expiration</label>
                <input className='form-control' type="text"  id="" value={formData?.[keyName]?.[crrIndex]?.battery_expiration} onChange={(e)=>handleInputChange(e,crrIndex)} disabled={is_unknowntrue} name="battery_expiration"  />
              </div> */}

          <BatteryExpiery
            is_unknowntrue={is_unknowntrue}
            crrFormData={crrFormData}
            handleDateChange={handleDateChange}
          />

          <div className="col form-group">
            <label htmlFor="">Battery lot</label>
            <input
              className="form-control"
              type="text"
              id=""
              value={HandleUnknow(formData?.[keyName]?.[crrIndex]?.battery_lot)}
              onChange={(e) => handleInputChange(e, crrIndex)}
              disabled={is_unknowntrue}
              name="battery_lot"
            />
          </div>

          <div className="col form-group">
            <label htmlFor="">Battery UDI</label>
            {/* <input className='form-control' type="text" id="" value={HandleUnknow( formData?.[ keyName ]?.[ crrIndex ]?.battery_uid) } onChange={ (e) => handleInputChange(e, crrIndex) } disabled={is_unknowntrue} name="battery_udi" /> */}
            <input
              className="form-control"
              type="text"
              id=""
              value={HandleUnknow(crrFormData?.battery_udi)}
              onChange={(e) => handleInputChange(e, crrIndex)}
              disabled={is_unknowntrue}
              name="battery_udi"
            />
          </div>

          <div className="col form-group">
            <label htmlFor="">9v Install</label>
            {/* <input className='form-control' type="text"  id="" value={formData?.[keyName]?.[crrIndex]?.v9_install} onChange={(e)=>handleInputChange(e,crrIndex)} disabled={is_unknowntrue} name="v9_install"  /> */}
            <CommonDatePicker
              is_readonly={is_unknowntrue}
              disabled={is_unknowntrue}
              calName={"v9_install"}
              CalVal={crrFormData?.v9_install}
              HandleChange={handleDateChange}
            />
          </div>

          <EditActionsComp
            index={0}
            crrIndex={crrIndex}
            formData={formData}
            setFormData={setFormData}
            section_name={keyName}
            crrFormData={crrFormData}
            unKnownToggleKey={unKnownToggleKey}
            type={"battery"}
            showAddRow={showAddRow}
            setShowAddRow={setShowAddRow}
          />
        </div>
      </>
    );
  }

  if (bettery_type === 1) {
    return (
      <>
        <div className="row" key={crrIndex}>
          <div className="col-12">
            <hr />
          </div>

          <EditBatteryComp
            formData={formData}
            crrFormData={crrFormData}
            BatteryList={BatteryList}
            handleInputChange={handleInputChange}
            crrIndex={crrIndex}
            is_readonly={is_unknowntrue}
          />
          {/* <div className='col-3 form-group' >
                <label htmlFor="">Battery Part </label>
                <input className='form-control' type="text"  id="" value={formData?.[keyName]?.[crrIndex]?.battery_type_id} onChange={(e)=>handleInputChange(e,crrIndex)} disabled={is_unknowntrue} name="battery_type_id"  />
              </div> */}

          {/* <div className='col-3 form-group' >
                <label htmlFor="">Battery Expiration</label>
                <input className='form-control' type="text"  id="" value={formData?.[keyName]?.[crrIndex]?.battery_expiration} onChange={(e)=>handleInputChange(e,crrIndex)} disabled={is_unknowntrue} name="battery_expiration"  />
              </div> */}
          <BatteryExpiery
            is_unknowntrue={is_unknowntrue}
            crrFormData={crrFormData}
            handleDateChange={handleDateChange}
          />

          <div className="col-3 form-group">
            <label htmlFor="">Battery lot</label>
            <input
              className="form-control"
              type="text"
              id=""
              value={HandleUnknow(formData?.[keyName]?.[crrIndex]?.battery_lot)}
              onChange={(e) => handleInputChange(e, crrIndex)}
              disabled={is_unknowntrue}
              name="battery_lot"
            />
          </div>

          <div className="col-3 form-group">
            <label htmlFor="">Battery UDI</label>
            {/* <input className='form-control' type="text" id="" value={HandleUnknow( formData?.[ keyName ]?.[ crrIndex ]?.battery_uid) } onChange={ (e) => handleInputChange(e, crrIndex) } disabled={is_unknowntrue} name="battery_udi" /> */}
            <input
              className="form-control"
              type="text"
              id=""
              value={HandleUnknow(crrFormData?.battery_udi)}
              onChange={(e) => handleInputChange(e, crrIndex)}
              disabled={is_unknowntrue}
              name="battery_udi"
            />
          </div>

          <EditActionsComp
            index={0}
            crrIndex={crrIndex}
            formData={formData}
            setFormData={setFormData}
            section_name={keyName}
            crrFormData={crrFormData}
            unKnownToggleKey={unKnownToggleKey}
            type={"battery"}
            showAddRow={showAddRow}
            setShowAddRow={setShowAddRow}
            is_unknowntrue={is_unknowntrue}
          />
        </div>
      </>
    );
  }

  return (
    <>
      {/* <div className=' bg-gray py-4 px-4 mt-4'> */}
      {/* <h2 className='heading'>{title} <button className='btn' onClick={addMore} >Add More</button></h2> */}

      {/* {formData?.BatteryInfo?.map((item,crrIndex)=>( */}
      <div className="row" key={crrIndex}>
        <div className="col-12">
          <hr />
        </div>

        <EditBatteryComp
          formData={formData}
          crrFormData={crrFormData}
          BatteryList={BatteryList}
          handleInputChange={handleInputChange}
          crrIndex={crrIndex}
          is_readonly={is_unknowntrue}
        />
        <EditBatteryComp
          formData={formData}
          crrFormData={crrFormData}
          BatteryList={BatteryList}
          handleInputChange={handleInputChange}
          crrIndex={crrIndex}
          is_readonly={is_unknowntrue}
        />
        {/* <div className='col-3 form-group' >
                <label htmlFor="">Battery Part </label>
                <input className='form-control' type="text"  id="" value={formData?.[keyName]?.[crrIndex]?.battery_type_id} onChange={(e)=>handleInputChange(e,crrIndex)} disabled={is_unknowntrue} name="battery_type_id"  />
              </div> */}

        {/* <div className='col-3 form-group' >
                <label htmlFor="">Battery Expiration</label>
                <input className='form-control' type="text"  id="" value={formData?.[keyName]?.[crrIndex]?.battery_expiration} onChange={(e)=>handleInputChange(e,crrIndex)} disabled={is_unknowntrue} name="battery_expiration"  />
              </div> */}
        <BatteryExpiery
          is_unknowntrue={is_unknowntrue}
          crrFormData={crrFormData}
          handleDateChange={handleDateChange}
        />

        <div className="col-3 form-group">
          <label htmlFor="">Battery lot</label>
          <input
            className="form-control"
            type="text"
            id=""
            value={HandleUnknow(formData?.[keyName]?.[crrIndex]?.battery_lot)}
            onChange={(e) => handleInputChange(e, crrIndex)}
            disabled={is_unknowntrue}
            name="battery_lot"
          />
        </div>

        <div className="col-3 form-group">
          <label htmlFor="">Battery UDI</label>
          <input
            className="form-control"
            type="text"
            id=""
            value={HandleUnknow(formData?.[keyName]?.[crrIndex]?.battery_uid)}
            onChange={(e) => handleInputChange(e, crrIndex)}
            disabled={is_unknowntrue}
            name="battery_udi"
          />
        </div>

        {Permissins?.has_9v ? (
          <div className="col-3 form-group mt-3">
            <label htmlFor="">9v Install</label>
            <input
              className="form-control"
              type="text"
              id=""
              value={formData?.[keyName]?.[crrIndex]?.v9_install}
              onChange={(e) => handleInputChange(e, crrIndex)}
              disabled={is_unknowntrue}
              name="v9_install"
            />
          </div>
        ) : (
          ""
        )}

        <EditInstallBeforeDateComp
          is_unknowntrue={is_unknowntrue}
          crrFormData={crrFormData}
          handleDateChange={handleDateChange}
        />
        {/* <div className='col-3 form-group' >
                <label htmlFor="">Install Before Date</label>
                <input className='form-control' type="text"  id="" value={formData?.[keyName]?.[crrIndex]?.install_before_date} onChange={(e)=>handleInputChange(e,crrIndex)} disabled={is_unknowntrue} name="install_before_date"  />
              </div> */}

        {/* <div className='col-3 form-group' >
                <label htmlFor="">Date Installed</label>
                <input className='form-control' type="text"  id="" value={formData?.[keyName]?.[crrIndex]?.date_installed} onChange={(e)=>handleInputChange(e,crrIndex)} disabled={is_unknowntrue} name="date_installed"  />
              </div> */}

        {/* <div className='col-3 form-group' >
                <label htmlFor="">Manufactured Date</label>
                <input className='form-control' type="text"  id="" value={formData?.[keyName]?.[crrIndex]?.manufactured_date} onChange={(e)=>handleInputChange(e,crrIndex)} disabled={is_unknowntrue} name="manufactured_date"  />
              </div> */}
        <InstalledDate

          is_unknowntrue={is_unknowntrue}
          crrFormData={crrFormData || defaultDate}
          handleDateChange={handleDateChange}
        />
        {Permissins?.has_man ? (
          <MenufectureDate
            is_unknowntrue={is_unknowntrue}
            crrFormData={crrFormData}
            handleDateChange={handleDateChange}
          />
        ) : (
          ""
        )}
      </div>
      {/* ))} */}
      {/* </div>  */}
    </>
  );
}

export default EditBatteryinformation;
